module.exports = __webpack_public_path__ + "media/assets/icons/kuro-circle-d03176374b5e4caea160551fbca17d0e.svg";